import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { AppState, RedirectLoginOptions } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

import { appName, startFromAccordion } from "../../config";
import { valueFromLocalStorage } from "../../utils/helpers";
import variableColors from "../../_App.module.scss";

const { primaryColor, appBackgroundColorWhiteSmoke } = variableColors;

const LoginContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 15%;
  button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    div.div-login {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      align-content: center;
      gap: 0.25rem;
      img {
        margin-right: 0.5rem;
        width: 3rem;
        height: 3rem;
      }
    }
    div.div-privacy-link {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      align-content: center;
      font-size: 55%;
      span {
        text-decoration: underline;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: ${primaryColor};
          background-color: ${appBackgroundColorWhiteSmoke};
        }
      }
    }
  }
`;

const LoginComponent = ({
  loginWithRedirect,
}: {
  loginWithRedirect: (options?: RedirectLoginOptions<AppState> | undefined) => Promise<void>;
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  //* Only Local Storage!
  const isStartingFromAccordion: boolean = valueFromLocalStorage("isStartingFromAccordion")
    ? JSON.parse(valueFromLocalStorage("isStartingFromAccordion") as string)
    : startFromAccordion;

  const handleLogin = async (): Promise<void> => {
    await loginWithRedirect({
      appState: {
        // returnTo: "/",
        returnTo: isStartingFromAccordion ? "/views/accordion" : "/",
      },
    });
  };

  const navigateToPrivacyPolicy = (event: React.MouseEvent<HTMLDivElement>): void => {
    event.stopPropagation();
    navigate("/window/privacy-policy");
  };

  return (
    <React.Fragment>
      {isStartingFromAccordion === false || isStartingFromAccordion === true ? (
        <LoginContainer>
          <Button onClick={handleLogin} variant={"primary"} size="lg">
            <div className="div-login">
              <img src={window.location.origin + "/bus.svg"} alt="Bus icon" />
              {t("Zaloguj się do")} <span className="span_bold">{appName}</span>
            </div>
            <div className="div-privacy-link" onClick={navigateToPrivacyPolicy}>
              <span> {t("Polityka Prywatności")}</span>
            </div>
          </Button>
        </LoginContainer>
      ) : null}
    </React.Fragment>
  );
};

export default LoginComponent;
